import {Component, QueryList, ViewChildren} from '@angular/core';
import {DateTime, NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {LogadoService} from "../../../providers/logado-service";
import {TAction, TPaymentFlag, TDevicerBios, TFinanceDate, TFinanceView, TPaymentStep, ENUM} from "../../../app/enum";
import {CONFIG} from "../../../app/config";
import {HotspotService} from "../../../providers/hotspot-service";
import {ModalActionPage} from "../modal-action/modal-action";
import {PaybookMenuPage} from '../paybook-menu/paybook-menu';

@Component({
    selector: 'page-gatewey-menu',
    templateUrl: 'gatewey-menu.html',
    providers: [HotspotService]
})
export class GateweyMenuPage {

    @ViewChildren(DateTime) iondates: QueryList<DateTime>;
    
    TDevicerBios: any = TDevicerBios;
    TPaymentFlag: any = TPaymentFlag;
    TPaymentStep: any = TPaymentStep;

    olhotag: number = 2;
    cointag: number = 3;

    enum: any = ENUM;
    config: any;
    logado: any;

    etapa: number;
    payfull: boolean;
    paymentTest: boolean;
    rootdeal: any;
    rootpaye: any;
    rootspot: any;

    findauth: string;
    analytic: any;

    gatewey: any;
    hotspotID: number;

    financeView: TFinanceView = TFinanceView.ceCash;
    financeDate: TFinanceDate;
    backupeDate: TFinanceDate;
    paymentStep: TPaymentStep;
    cashday: string;

    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public hotspotService: HotspotService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.gatewey = this.navParams.get('gatewey');
        this.hotspotID = this.util.anyParams(0, this.navParams.get('hotspotID'));
        this.cashday = this.util.anyParams(this.util.dateToStr(null), this.navParams.get('cashday'));
        this.paymentTest = this.navParams.get('paymentTest');
        this.financeDate = this.navParams.get('financeDate');
        this.paymentStep = this.navParams.get('paymentStep');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Compra History', '/perfil-compra');

        if (this.etapa == 0) this.gatewayLoad();
        if (this.etapa == 1) this.hotspotGate();
        if (this.etapa == 2) this.paymentLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        if (this.etapa == 0) return 'Relatório';
        if (this.etapa == 1) return this.gatewey.GateweyNome;
        if (this.etapa == 2) return (this.paymentTest ? 'Autenticação' : 'Resgate');

    }

    gatewayLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.conveny(TAction.acLoad, this.gatewey.GateweyID, this.hotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.rootdeal = data,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    paymentLoad() {

        //Corrige Lastday Exemplo: vem 2021-02-31 troca para 2021-02-28
        this.cashday = this.util.dateLast(this.cashday);

        let params = '&PaymentStep=' + this.paymentStep + '&Cashday=' + this.cashday + '&FinanceDate=' + this.financeDate + '&PaymentTest=' + this.paymentTest;

        this.rootpaye = null;
        this.hotspotService.payment(TAction.acGate, this.gatewey.GateweyID, this.hotspotID, '', params)
            .subscribe(
                data => this.rootpaye = data,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    paybookMenu(payment) {

        let branded = payment.Hotspot.Branded; //{BrandedID: 0}
        let object = {etapa: 0, olhaapp: true, fronter: true, profile: null, branded: branded, userset: null, paybookID: payment.PaybookID, paybook: null};
        this.util.modalopen(PaybookMenuPage, 'alto', false, object).subscribe();

    }

    convenyOpen() {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Pay',     handler: () => this.repasseGate(false)});
        buttons.push({text: 'Auth',    handler: () => this.repasseGate(true)});
        buttons.push({text: 'Setting', handler: () => alert('Develop')});
        this.util.sheetOpen(buttons, 'SETTING');
        
    }

    hotspotGate() {

        //Corrige Lastday Exemplo: vem 2021-02-31 troca para 2021-02-28
        this.cashday = this.util.dateLast(this.cashday);

        let params = '&PaymentStep=' + this.paymentStep + '&Cashday=' + this.cashday + '&FinanceDate=' + this.financeDate;
        params = '&GateweyID=' + this.gatewey.GateweyID + params;

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.hotspot(TAction.acGate, 0, 0, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.rootspot = data,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    repasseOpen() {

        let cashday = this.util.dateToStr(null);

        let object = {etapa: 1, hotspotID: 0, gatewey: this.gatewey, financeDate: TFinanceDate.fdEra, paymentStep: TPaymentStep.psPrevisto, cashday: cashday};
        this.util.modalopen(GateweyMenuPage, 'full', false, object).subscribe();

    }

    repasseGate(paymentTest: boolean) {

        let cashday = this.util.dateToStr(null);
        let step = (paymentTest ? TPaymentStep.psNone : TPaymentStep.psPrevisto);

        let object = {etapa: 2, hotspotID: 0, gatewey: this.gatewey, financeDate: TFinanceDate.fdMes, paymentStep: step, paymentTest: paymentTest, cashday: cashday};
        this.util.modalopen(GateweyMenuPage, 'full', false, object).subscribe();

    }

    repassePaga(line) {

        let onOkey = (okey, that, data) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.payment(TAction.acGate, 0, line.HotspotID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => that.dismiss(),
                    erro => this.util.alertResult(erro)
                );

        };

        let lucro = 'Ágio de <b>' + this.util.dinheiro(line.Payback.PaymentMore) + '</b> da antecipação.';
        let texto = (!line.GatewayReter ? '' : lucro);

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'gatewaypay', onOkey, null, true, texto)};

        //Custom - Setvalue
        objectData.modalinfo.valor$.real = this.util.dinheiro(line.Payback.PaymentCash - line.Payback.PaymentGate - line.Payback.PaymentMore);
        objectData.modalinfo.resumo = '<b>' +line.ProfileRnid + '</b>' + '<br>' + (line.Account.Branded.BrandedID + '').substring(2, 5) + ' - ' + line.Account.Branded.BrandedNome + '<br>' + line.Account.AccountNoag + ' • ' + line.Account.AccountNocc;
      //objectData.modalinfo.linhas[0].right = '<b>' + this.util.dinheiro(line.GatewayPreco - line.GatewayPrice) + '</b>';
      //objectData.modalinfo.linhas[1].right = '<b>' + this.util.dinheiro(line.GatewayPrice - line.GatewayReter) + '</b>';
      //objectData.modalinfo.linhas[2].right = '<b>' + this.util.dinheiro(line.GatewayGasto) + '</b>';
        objectData.modalinfo.select = null;

        this.util.modalopen(ModalActionPage, 'quad', true, objectData).subscribe();

    }

    repasseTaxa() {

        let onOkey = (okey, that, data) => {

            let loading = this.util.loadingDots();
            loading.present();

            this.hotspotService.payment(TAction.acSend, 0, this.hotspotID)
                .finally(() => loading.dismiss())
                .subscribe(data => {
                        this.dismiss();
                        that.dismiss();
                    }, erro => this.util.alertResult(erro)
                );

        };

        let pays = this.paymentList(this.payfull ? null : true);
        let cash = this.util.jsSum(pays, ['PaymentCash']);
        let taxa = this.util.jsSum(pays, ['PaymentTaxa']);
        let gate = this.util.jsSum(pays, ['PaymentGate']);
        let over = this.util.jsSum(pays, ['PaymentMore']);  //Antecipacao
        let total = (cash - taxa - gate - over);

      //let texto = 'Ágio de <b>' + this.util.dinheiro(over) + '</b> da antecipação.';
        let texto = 'Você receberá o valor acima.';
        let objectData = {modalinfo: this.config.modalinfo(this.util, 'gatewaypay', onOkey, null, false, texto)};

        //Custom - Setvalue
        objectData.modalinfo.valor$.real = this.util.dinheiro(total);
      //objectData.modalinfo.linhas[0].right = '<b>' + this.util.dinheiro(over) + '</b>';

        if (total) this.util.modalopen(ModalActionPage, 'quad', true, objectData).subscribe();

    }

    payfindAuth() {

        if (this.findauth.length == 20) {

        }

    }

    hotspotSoma(hotspot): number {

        let hotspots = (hotspot ? [hotspot] : this.rootspot.Hotspots);

        if (this.cointag == 1) return this.util.jsSum(hotspots, ['Payback', 'PaymentCash']);
        if (this.cointag == 2) return this.util.jsSum(hotspots, ['Payback', 'PaymentTaxa']);
        if (this.cointag == 3) return this.util.jsSum(hotspots, ['Payback', 'PaymentCash']) - this.util.jsSum(hotspots, ['Payback', 'PaymentGate']) - this.util.jsSum(hotspots, ['Payback', 'PaymentMore']);
        if (this.cointag == 4) return this.util.jsSum(hotspots, ['Payback', 'PaymentGate']);
        if (this.cointag == 5) return this.util.jsSum(hotspots, ['Payback', 'PaymentMore']);

    }

    paymentList(payfree: boolean): any {

        if (this.olhotag == 0) return this.rootpaye.Payments;
        if (this.olhotag == 1) return this.rootpaye.Payments.filter(PA => PA.PaymentFlag == TPaymentFlag.cpProcess);
        if (this.olhotag == 2) return this.rootpaye.Payments.filter(PA => PA.PaymentFlag >= TPaymentFlag.cpRealizado && (payfree == null || PA.PaymentFree == payfree));
        if (this.olhotag == 3) return this.rootpaye.Payments.filter(PA => PA.PaymentFlag == TPaymentFlag.cpCancelado);

    }

    hotviewOlho(flug: null | 'icon'): string {

        if (flug == 'icon') {

            if (this.financeView == TFinanceView.ceCash) return 'b-icon-dollar';
            if (this.financeView == TFinanceView.ceCent) return 'b-icon-percent';
            if (this.financeView == TFinanceView.ceQtde) return 'b-icon-box';

        }

        if (flug == null) {

            let onView = (view : TFinanceView) => {
                this.financeView = view;
                //this.storageService.set('FINANCE-VIEW', this.financeView).subscribe();
            }

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'R$',  handler: () => onView(TFinanceView.ceCash)});
            buttons.push({text: '%',   handler: () => onView(TFinanceView.ceCent)});
            buttons.push({text: 'Qtd', handler: () => onView(TFinanceView.ceQtde)});
            this.util.sheetOpen(buttons, 'VIEW');

        }

    }


    hotviewDate(flug: null | 'text' | 'done'): string {

        if (flug == 'done') {
            this.rootspot = null;
            this.financeDate = this.backupeDate;
            if (this.etapa == 1) this.hotspotGate();
            if (this.etapa == 2) this.paymentLoad();
            return null;
        }

        if (flug == 'text') {
            if (this.financeDate == TFinanceDate.fdEra) return 'Período';
            let dia: null | 'dd' = (this.financeDate == TFinanceDate.fdDia ? 'dd' : null);
            let mes: null | 'char' = (this.financeDate != TFinanceDate.fdAno ? 'char' : null);
            return this.util.dataft(this.cashday, dia, mes, 'yyyy');
        }


        if (flug == null) {

            let onDate = (financeDate) => {
                this.backupeDate = financeDate;
                if (financeDate == TFinanceDate.fdEra) this.hotviewDate('done');
                if (financeDate != TFinanceDate.fdEra) this.iondates.toArray()[financeDate].open();
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Dia', handler: () => onDate(TFinanceDate.fdDia)});
            buttons.push({text: 'Mês', handler: () => onDate(TFinanceDate.fdMes)});
            buttons.push({text: 'Ano', handler: () => onDate(TFinanceDate.fdAno)});
            buttons.push({text: 'Era', handler: () => onDate(TFinanceDate.fdEra)});
            this.util.sheetOpen(buttons, 'DATE');
            return null;

        }

    }

    hotviewLeft() {

        let onLoad = (step) => {
            this.paymentStep = step;
            if (this.etapa == 1) this.hotspotGate();
            if (this.etapa == 2) this.paymentLoad();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Previsto',  handler: () => onLoad(TPaymentStep.psPrevisto)});
        buttons.push({text: 'Liquidado', handler: () => onLoad(TPaymentStep.psLiquidado)});
        buttons.push({text: 'Resgatado', handler: () => onLoad(TPaymentStep.psResgatado)});
        this.util.sheetOpen(buttons, 'CONTA');

    }



    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/gatewey-menu/gatewey-menu.ts